import type { ReactNode } from 'react'

import { PlayerAuthProvider } from './PlayerAuthContext'
import { PlayerProvider } from './PlayerContext'
import { StatsProvider } from './StatsContext'

// The player account stack. Order matters: the profile needs the signed-in user,
// and stats wait for the profile so a signed-in player's first read covers
// every device on the account.
export const AccountProviders = ({ children }: { children: ReactNode }) => (
  <PlayerAuthProvider>
    <PlayerProvider>
      <StatsProvider>{children}</StatsProvider>
    </PlayerProvider>
  </PlayerAuthProvider>
)
